import api from "../api/api";

/* =========================
   Promotions API helpers
========================= */

const normalizeList = (res) => {
  const d = res?.data;

  if (Array.isArray(d?.data)) return d.data;
  if (Array.isArray(d)) return d;
  if (Array.isArray(d?.data?.data)) return d.data.data;

  return [];
};

export const PromotionServices = {
  async getPromotions() {
    const res = await api.get("/get-promotions");
    return normalizeList(res);
  },
};